import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { formatMoney, toShamsi } from '../utils/api';

export default function Loans() {
  const [loans, setLoans] = useState([]);
  const [filter, setFilter] = useState('active');
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => { api.get('/loans').then(r => setLoans(r.data)); }, []);

  const filtered = loans
    .filter(l => filter === 'all' || l.status === filter)
    .filter(l => `${l.first_name} ${l.last_name} ${l.phone || ''}`.includes(search));

  const totalDebt = filtered.reduce((s, l) => s + Number(l.remaining_amount), 0);

  return (
    <div>
      <div className="page-header">
        <h1>مدیریت وام‌ها</h1>
        <input className="search-input" placeholder="🔍 جستجوی مشتری..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      {/* فیلتر وضعیت */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
        {[['active', '🔴 فعال'], ['partial', '🟡 جزئی'], ['paid', '🟢 تسویه'], ['all', 'همه']].map(([val, label]) => (
          <button key={val} className={`btn ${filter === val ? 'btn-primary' : 'btn-outline'}`} onClick={() => setFilter(val)}>{label}</button>
        ))}
        {filter !== 'paid' && (
          <div style={{ marginRight: 'auto', background: 'var(--card)', borderRadius: 8, padding: '8px 16px', border: '1px solid var(--border)', fontSize: 13 }}>
            مجموع بدهی: <strong style={{ color: 'var(--danger)' }}>{formatMoney(totalDebt)}</strong>
          </div>
        )}
      </div>

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>مشتری</th><th>تماس</th><th>شماره فاکتور</th><th>مجموع وام</th><th>پرداخت شده</th><th>باقی</th><th>وضعیت</th><th>تاریخ</th><th>عملیات</th></tr>
            </thead>
            <tbody>
              {filtered.map(l => (
                <tr key={l.id}>
                  <td style={{ fontWeight: 600 }}>{l.first_name} {l.last_name}</td>
                  <td style={{ fontSize: 12 }}>{l.phone || '—'}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 11 }}>{l.invoice_number || '—'}</td>
                  <td>{formatMoney(l.total_amount)}</td>
                  <td style={{ color: 'var(--success)' }}>{formatMoney(l.paid_amount)}</td>
                  <td style={{ fontWeight: 700, color: Number(l.remaining_amount) > 0 ? 'var(--danger)' : 'var(--success)' }}>
                    {formatMoney(l.remaining_amount)}
                  </td>
                  <td>
                    <span className={`badge ${l.status === 'paid' ? 'badge-success' : l.status === 'partial' ? 'badge-warning' : 'badge-danger'}`}>
                      {l.status === 'paid' ? '✓ تسویه' : l.status === 'partial' ? 'جزئی' : 'فعال'}
                    </span>
                  </td>
                  <td style={{ fontSize: 12 }}>{toShamsi(l.created_at)}</td>
                  <td>
                    <button className="btn btn-outline btn-sm" onClick={() => navigate(`/loans/${l.id}`)}>📋 جزئیات</button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan={9} style={{ textAlign: 'center', padding: 32, color: 'var(--text-muted)' }}>وامی یافت نشد</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
